import { accountsSelectors } from 'companion-app-components/flux/accounts';
import { isAccountDisconnected } from 'companion-app-components/flux/accounts/accountsUtils';
import store from 'store';

export const isC2REnabledAccount = (accountId) => {
  const account = accountsSelectors.getAccountById(store?.getState(), accountId);
  return account && !isAccountDisconnected(account) && account?.isC2REnabled;
};
